// ── 상담자별 계약 — 데스크탑 패널 (2026-06-07) ─────────────────────────────
// contracts_by_person 분리. 상담자(tmRows) 데이터만 표시.
//
// L 사이즈 통일 디자인:
//   - border-t accent violet (UnifiedCard 기본)
//   - 헤더: 라벨 + chevron 월 nav + 핵심값 (총 N장, text-xl violet)
//   - 구분선 (border-t-violet-100) 후 본문
//   - watermark 우측 하단 (FileSignature)

import React from 'react';
import { FileText, FileSignature } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { useContractMonth } from './useContractMonth';
import { UnifiedCard } from './UnifiedCard';
import { ContractTable } from './contractTable/ContractTable';
import { accentText, accentBorder } from './widgetAccent';

// code·title·byMonthUrl(2026-10-19) — 회사별·통합 계약 위젯이 같은 패널을 쓴다(기본값 = 본사 위젯 그대로).
export function ContractByConsultantPanel({
  accentOverride, sortableId, onClick,
  code = 'contracts_by_consultant', title = '상담자별 계약', byMonthUrl,
  summaryCode, // 위젯 메뉴가 없는 직원 — 카드 요약 길로 그달 표(2026-10-24)
}) {
  const {
    year,
    month,
    setYearMonth,
    loading,
    tmRows,
    productColumns,
    categoryColumns,
  } = useContractMonth(byMonthUrl, { summaryCode });

  const ym = `${year}-${String(month).padStart(2, '0')}`;
  const handleMonthChange = (next) => {
    if (!/^\d{4}-\d{2}$/.test(next)) return;
    const [y, m] = next.split('-').map(Number);
    setYearMonth(y, m);
  };

  const totalCount = (tmRows || []).reduce((s, r) => s + (Number(r.total) || 0), 0);
  const totalText = totalCount.toLocaleString('ko-KR', { maximumFractionDigits: 1 });
  const tone = accentOverride || 'violet';

  return (
    <UnifiedCard
      code={code}
      title={title}
      icon={FileText}
      accent="violet"
      accentOverride={accentOverride}
      size="L"
      monthNavigate
      month={ym}
      onMonthChange={handleMonthChange}
      sortableId={sortableId}
      sub={loading ? '불러오는 중...' : null}
      watermarkIcon={FileSignature}
      onClick={onClick}
    >
      <div className="flex items-baseline justify-end gap-1 mb-2">
        <span className="text-[10px] font-bold text-[var(--text-sub)] uppercase tracking-wider">총</span>
        <span className={cn('text-xl font-black tabular-nums leading-none', accentText(tone))}>
          {totalText}
        </span>
        <span className="text-[10px] font-bold text-[var(--text-sub)] uppercase tracking-wider">장</span>
      </div>
      <div className={cn('border-t mx-1 my-1.5', accentBorder(tone))} />
      <ContractTable
        rows={tmRows}
        nameLabel="상담자"
        productColumns={productColumns}
        categoryColumns={categoryColumns}
      />
    </UnifiedCard>
  );
}
